import styled from 'styled-components';

const RootWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;

  & #main {
    flex: 1 0 auto;
  }
  & #footer {
    flex-shrink: 0;
  }
  @media (max-width: 1023px) {
    visibility: hidden;
  }
`;

export default RootWrapper;
